import React from "react";
import cancelImage from "../../../assets/images/cancelIcn.svg";
import Button from "../../../components/atoms/Button";
import styles from "./style.module.css";

const GeneralError = ({
  title = "Something went wrong",
  description = "Please try again",
}) => {
  const relodandNavigate = () => {
    window.location.reload(true);
  };
  return (
    <div className={styles.msgStyle}>
      <img src={cancelImage} alt="error" />
      <div className={styles.title1}>{title}</div>
      <div className={styles.title3}>{description}</div>
      <div className={styles.btn}>
        <Button
          width={"35vh"}
          onclick={() => relodandNavigate()}
          height={"5vh"}
          text={"Refresh"}
          backgroundColor={"#0075FF"}
          border={"none"}
          color={"#fff"}
        ></Button>
      </div>
    </div>
  );
};

export default GeneralError;
